import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";

import startWeekReducer from "../features/meals/startWeekSlice";

export default combineReducers({
  startWeek: startWeekReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
});
